import { Component, Inject, OnInit } from "@angular/core";
import { ELEMENT_COLUMNS } from "@/modules/elements/components/element-details-modal/components/element-tag/element-tag.const";
import {
  ElementTagDatasource,
} from "@/modules/elements/components/element-details-modal/components/element-tag/element-tag.datasource";
import { ElementDetailsGQL } from "@/core/graphql/graphql";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  selector: 'cosmos-element-tag',
  templateUrl: 'element-tag.component.html',
  styleUrls: ['element-tag.component.scss'],
})

export class ElementTagComponent implements OnInit {
  public _columns = ELEMENT_COLUMNS;
  public _dataSource: ElementTagDatasource;

  public constructor(
    private readonly _elementDetailsGql: ElementDetailsGQL,
    @Inject(MAT_DIALOG_DATA) private readonly data: { elementId: number },
  ) {
    this._dataSource = new ElementTagDatasource(_elementDetailsGql, this.data.elementId);
  }

  public ngOnInit(): void {
    this._dataSource.loadData();
  }
}
